export const TALK_TO_US = {
  EN: 'http://find.uniplaces.com/talk-to-us/',
  ES: 'http://find.uniplaces.com/hable-con-nosotros/',
  PT: 'http://find.uniplaces.com/fale-conosco/',
  FR: 'http://find.uniplaces.com/parle-nous/',
  IT: 'http://find.uniplaces.com/parla-con-noi/',
  DE: 'http://find.uniplaces.com/sprechen-sie-uns-an/',
  NL: 'http://find.uniplaces.com/talk-to-us/',
  PL: 'http://find.uniplaces.com/talk-to-us/',
  ZH: 'http://find.uniplaces.com/talk-to-us/'
};

export const CITY_GUIDES = {
  EN: 'https://find.uniplaces.com/guides/',
  ES: 'https://find.uniplaces.com/giuas-de-la-ciudad/',
  PT: 'https://find.uniplaces.com/guias-da-cidade/',
  FR: 'https://find.uniplaces.com/guides-de-villes/',
  IT: 'https://find.uniplaces.com/guide-della-citt/',
  DE: 'https://find.uniplaces.com/stadtfhrer/',
  NL: 'https://find.uniplaces.com/guides/',
  PL: 'https://find.uniplaces.com/guides/',
  ZH: 'https://find.uniplaces.com/guides/'
};
